export const MINIMUN_TO_VALIDADE = 1
export const MAX_TO_VALIDADE = 5
export const NO_SEAT = 0
export const SAME_AMOUNT = 'SAME_AMOUNT'
export const MISSING = 'MISSING'
export const VALID = 'VALID'
